import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        state: '',
        userType: '', //farmer, subdist, dist, sale
        theme: '', //
        tier: '',
        isAmbassador: false,
        aiaConfig: null,
        ambassadorCatId: null,
        categoryCardIds: [],
        closeWebUrl: null,
        profileLbl: null,
        welcomeLbl: null,
        deeplinks: null
    },
	actions: {

	},
	mutations: {
        changeState (state, stateName) {
            state.state = stateName;
        },
        changeUserType (state, userType) {
            state.userType = userType;
        },
        changeTheme (state, theme) {
            state.theme = theme;
        },
        changeTier (state, tier) {
            state.tier = tier;
        },
        changeIsAmbassador (state, isAmbassador) {
            state.isAmbassador = isAmbassador;
        },
        setAiaConfig (state, config) {
            state.aiaConfig = config;
            state.ambassadorCatId = config.ambassadorCatId;
            state.categoryCardIds = config.categoryCardIds;
            state.closeWebUrl = config.close;
            state.closeAiaPlusUrl = config.closeAiaPlus;
            state.profileLbl = config.profile_lbl;
            state.welcomeLbl = config.welcome;
            state.deeplinks = config.deeplinks;
        }
    },
	getters:{
        getAiaConfig: (state) => {
            return state.config;
        },
        getAmbassadorCatId: (state) => {
            return state.ambassadorCatId;
        },
        getCloseWebUrl: (state) => {
            return state.closeWebUrl;
        },
        getCloseAiaPlusUrl: (state) => {
            return state.closeAiaPlusUrl;
        },
        getCategoryCardIds: (state) => {
            return state.categoryCardIds;
        },
        getIsInCategoryCardIds: (state) => (id) => {
            return (state.categoryCardIds.find(val => val == id));
        },
        getProfileLbl: (state) => {
            return state.profileLbl;
        },
        getProfileLblByLocaleCode: (state) => (localeCode) => {
            return state.profileLbl[localeCode];
        },
        getWelcomeLbl: (state) => {
            return state.welcomeLbl;
        },
        getWelcomeLblByLocaleCode: (state, localeCode) => {
            return state.welcomeLbl[localeCode];
        },
        getDeeplinks: (state) => {
            return state.deeplinks;
        }
	}
});
